import Pagination from './pagination';
import PageItemCount from './page_item_count';
export default {
    Pagination,
    PageItemCount,
}